var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.widgetSettings && _vm.widgetSettings.length > 0
    ? _c("div", [
        _c("div", { staticClass: "dashboard-view" }, [
          _c(
            "div",
            {
              staticClass:
                "container-fluid fixed-top-bar-padding dashboard-wrapper"
            },
            [
              _c(
                "div",
                {
                  staticClass: "dashboard-view-header",
                  staticStyle: { "z-index": "700" }
                },
                [
                  _c("div", { staticClass: "media-call-icon" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/csmworkflow/img/media-call.svg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "view-header-title" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("span", { staticClass: "lastUpdate" }, [
                      _vm._v(
                        "Last Updated " +
                          _vm._s(
                            _vm._f("moment")(
                              _vm.lastUpdatedDate,
                              "MMM D,YYYY HH:mm a"
                            )
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "offLineMessage" }, [
                      _vm._v(_vm._s(_vm._f("offlineMessage")(_vm.isOnLine)))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.widgetSettings[0].json_value.today.visibility
                ? _c("div", { staticClass: "dashboard-graphs" }, [
                    _c("div", { staticClass: "dashboard-header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: " stats-border breakpoint__fix" },
                          [
                            _c(
                              "div",
                              { staticClass: "dashboard-stats" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "stats-left-name-wrap" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "stats-left-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.widgetSettings[0].json_value
                                              .today.label
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.widgetSettings[0].json_value.today
                                    .columns,
                                  function(status) {
                                    return _c("NumberStat", {
                                      key: status.dashboardType,
                                      attrs: { statusData: status }
                                    })
                                  }
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.widgetSettings[0].json_value.closed.visibility
                ? _c("div", { staticClass: "dashboard-graphs" }, [
                    _c("div", { staticClass: "dashboard-header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: " stats-border breakpoint__fix" },
                          [
                            _c(
                              "div",
                              { staticClass: "dashboard-stats" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "stats-left-name-wrap" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "stats-left-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.widgetSettings[0].json_value
                                              .closed.label
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.widgetSettings[0].json_value.closed
                                    .columns,
                                  function(status) {
                                    return _c("NumberStat", {
                                      key: status.dashboardType,
                                      attrs: { statusData: status }
                                    })
                                  }
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.widgetSettings[0].json_value.trending.visibility
                ? _c("div", { staticClass: "dashboard-graphs" }, [
                    _c(
                      "div",
                      { staticClass: "dashboard-header" },
                      _vm._l(
                        _vm.widgetSettings[0].json_value.trending.columns,
                        function(status) {
                          return _c("GraphStat", {
                            key: status.dashboardType,
                            attrs: { statusData: status }
                          })
                        }
                      ),
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.widgetSettings[0].json_value.graph.visibility
                ? _c(
                    "div",
                    { staticClass: "dashboard-graphs" },
                    [
                      _c(
                        "perfect-scrollbar",
                        _vm._l(
                          _vm.widgetSettings[0].json_value.graph.columns,
                          function(status) {
                            return _c("GraphStat", {
                              key: status.dashboardType,
                              attrs: { statusData: status }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dashboard-right-list" }, [
          _vm.widgetSettings[0].json_value.list.visibility
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                _vm._l(_vm.widgetSettings[0].json_value.list.columns, function(
                  status
                ) {
                  return _c("DeliverableList", {
                    key: status.dashboardType,
                    attrs: { statusData: status },
                    on: { lastUpdated: _vm.lastUpdated }
                  })
                }),
                1
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "listTitle" }, [
      _c("h2", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("Media Call Dashboard")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }